<template>
  <main class="max-w-4xl mx-auto px-6 py-12 text-zinc-100">
    <h1 class="text-3xl font-bold mb-6">Widerrufsbelehrung</h1>
    
    <section class="mb-8">
      <h2 class="text-xl font-semibold mb-2">Aktueller Hinweis</h2>
      <p>
        Derzeit können über unsere Website <strong>keine verbindlichen Bestellungen oder Buchungen</strong> abgeschlossen werden.
        Die folgenden Informationen dienen ausschließlich der gesetzlichen Informationspflicht nach dem Fern- und
        Auswärtsgeschäfte-Gesetz (FAGG) und gelten <strong>erst</strong>, sobald eine Online-Buchungsfunktion aktiviert wird.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-xl font-semibold mb-2">Widerrufsrecht (für künftige Online-Buchungen)</h2>
      <p>
        Verbraucher haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen einen abgeschlossenen Vertrag zu
        widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
      </p>
      <p class="mt-4">
        Um das Widerrufsrecht auszuüben, müssen Sie uns
        <br />
        <strong>Mody Veranstaltungstechnik</strong><br />
        Inhaber: Stefan Schäfer<br />
        Adresse: Ennspark 193, 5542 Flachau<br />
        Telefon: +43 664 2247433<br />
        E-Mail: info@mody.at<br />
        mittels einer eindeutigen Erklärung (z. B. per E-Mail) über Ihren Entschluss, den Vertrag zu widerrufen, informieren.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-xl font-semibold mb-2">Folgen des Widerrufs</h2>
      <p>
        Wenn Sie einen Vertrag widerrufen, erstatten wir alle erhaltenen Zahlungen binnen vierzehn Tagen nach Eingang Ihrer
        Mitteilung. Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
        eingesetzt haben, sofern nichts anderes vereinbart wurde.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-xl font-semibold mb-2">Vorzeitiges Erlöschen des Widerrufsrechts</h2>
      <p>
        Bei Miet- oder Dienstleistungsverträgen (z. B. Vermietung von Veranstaltungstechnik) erlischt das Widerrufsrecht
        vorzeitig, wenn wir – mit Ihrer ausdrücklichen Zustimmung – vor Ablauf der Widerrufsfrist mit der Leistung beginnen
        und Sie bestätigt haben, dass Sie durch den vorzeitigen Beginn Ihr Widerrufsrecht verlieren.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-xl font-semibold mb-2">Ausschluss des Widerrufsrechts</h2>
      <p>
        Das Widerrufsrecht besteht nicht bei Verträgen mit Unternehmern (B2B) oder bei vollständig erbrachten Leistungen.
      </p>
    </section>

    <section>
      <h2 class="text-xl font-semibold mb-2">Muster-Widerrufsformular</h2>
      <p>(Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden Sie es an uns zurück.)</p>
      <pre class="bg-zinc-900 p-4 rounded-md text-sm mt-4 whitespace-pre-wrap">
An  
Mody Veranstaltungstechnik  
info@mody.at
E-Mail: [E-Mail-Adresse einfügen]

Hiermit widerrufe ich den abgeschlossenen Vertrag über die Vermietung der folgenden Veranstaltungstechnik/Dienstleistung:  
_______________________________________________________  
Gebucht am: _______________ / Veranstaltung am: _______________  
Name des Verbrauchers: ____________________________  
Anschrift: _________________________  
Datum: _______________  
Unterschrift (nur bei Mitteilung auf Papier)
      </pre>
    </section>
  </main>
</template>

<script setup lang="ts">
useSeoMeta({
  title: 'Widerrufsbelehrung',
  description:
    'Widerrufsbelehrung für Mody Veranstaltungstechnik gemäß Fern- und Auswärtsgeschäfte-Gesetz (FAGG). Informationen zum Widerrufsrecht bei zukünftigen Online-Buchungen.',
})
</script>

<style scoped>
main {
  line-height: 1.6;
}
</style>
